import { grey, primary } from 'src/theme/palette';

export const toggleButtonGroup = { borderRadius: 0, border: 'none', flexWrap: 'wrap' };

export const toggleButtonIcon = ({ field, options }) => ({ mr: 1, color: field.value === options.value ? primary.main : grey[400] });
export const helperTextStyle = { px: 2, textTransform: 'capitalize' };
export const typoStyle = { m: '0 0 10px' };